import { Pipe, PipeTransform } from '@angular/core';
import { WorkflowItemNavigationService } from '@workflow/services/workflow-item-navigation.service';
import { IWorkflowItem } from '@interfaces/interfaces';

@Pipe({ 
	name: 'workflowStepUrl',
	pure: true
})
export class WorkflowStepUrlPipe implements PipeTransform {
	constructor(private readonly workflowItemNavigationService:WorkflowItemNavigationService) {}
	
	transform(step:IWorkflowItem): string {
		return this.workflowItemNavigationService.getFirstAvailableEntryURL(step);
	}

}
